<template>
  <el-dialog title="日志信息"
             :visible.sync="dialogFormVisible"
             custom-class="min-dialog"
             center
             :close-on-click-modal="false"
             :modal="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="客户" :label-width="formLabelWidth" prop="customername">
            <AutoCustomer @clear="clearCustomerName" :size="''" @handleSelect="afterSelExternalDept"
                          :content="form.customername"></AutoCustomer>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="内容" :label-width="formLabelWidth" prop="remark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 10, maxRows: 10}"
              placeholder="请输入内容"
              v-model="form.remark">
            </el-input>

          </el-form-item>
        </el-col>
      </el-row>
      <el-row>

      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable" v-if="canEdit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getDetail, save} from '@/api/set/trackinglog';


  export default {
    name: "TrackingLogEdit",
    data() {
      return {
        uguid:'',
        canEdit:false,
        dialogFormVisible: false,
        isDisable: false,
        auditstatus:'',
        form: {  //表单数据
          customerserial: '',
          customername: '',
          remark: '',
          auditstatus:'',
          unitguid: ''
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          customername: [
            {required: true, message: '请选择客户', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      clearCustomerName() {
        this.form.customerserial = ""
      },
      //选择门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.form.customerserial = customerserial
        this.form.customername = customername
      },
      show(auditstatus) {
        this.initForm();
        this.auditstatus=auditstatus;
        this.dialogFormVisible = true;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.isDisable = true;
            this.form.auditstatus=this.auditstatus;
            save(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;
                this.$emit('bindGrid');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.isDisable = false;
            });
          }
        })
      },
      initData(unitguid) {
        this.form.unitguid = unitguid
        getDetail({unitguid: unitguid}).then(response => {
          this.form = response.data.obj
          this.canEdit=this.uguid==this.form.uguid;

        })
      },
      initForm() {
        for (let i in this.form) {
          this.form[i] = ''
        }
        this.canEdit=true;
        this.isDisable = false
      },
    },
    mounted() {
      let model = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.uguid=model.uguid;
    },
    components: {}
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }
</style>





// WEBPACK FOOTER //
// src/components/workflow/waitaudit/TrackingLogEdit.vue